export const platoUrls = {
    dev: "https://cdn.plato.immo/w.staging.js",
    preview: "https://cdn.plato.immo/w.staging.js",
    live: "https://cdn.plato.immo/w.js",
};
